import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {PerformanceReviewQuestion, PerformanceReviewReviewee} from 'main/stores/performance_reviews/index';

class PerformanceReviewResult extends DomainObject {
  trend;
  reviewees;
  questions;

  _relations = {
    reviewees: [PerformanceReviewReviewee],
    questions: [PerformanceReviewQuestion]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      trend: observable,
      reviewees: observable,
      questions: observable
    });

    this.merge(other);
  }
}

export default PerformanceReviewResult;
